import { LinearProgress, linearProgressClasses, useTheme } from '@mui/material';
import { Theme } from '@shape-ds/components';
import { NOT_CALCULATED } from 'pages/Reports/Rert/RertDateProvider';
import React from 'react';
import './style.scss';

interface HealthBarProps {
  health: string;
  showText?: boolean;
}
const getHealthColor = (health: string) => {
  if (health === NOT_CALCULATED) {
    return 'gray';
  }
  if (Number(health) < 30) {
    return 'red';
  }
  if (Number(health) < 70) {
    return 'yellow';
  }
  return 'green';
};

const HealthBar: React.FC<HealthBarProps> = ({ health, showText }) => {
  const theme = useTheme<Theme>();
  const healthIsNC = health === NOT_CALCULATED;
  return (
    <span className="health-bar">
      {showText && <strong>{healthIsNC ? health : `${health}%`}</strong>}
      <LinearProgress
        variant="determinate"
        value={healthIsNC ? 0 : Number(health)}
        sx={{
          [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
          },
          [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 5,
            backgroundColor: theme.tokens.colors[getHealthColor(health)][1],
          },
        }}
      />
    </span>
  );
};

export default HealthBar;
